import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaWhatsapp,
  FaInstagram,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import Navbar from "./Navbar";
import "./home.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import SEO from "../components/SEO";

export default function Home() {
   const [showCallText, setShowCallText] = useState(true);
   const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
    const handlePageLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCallText(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
     {isLoading && (
        <div className="flawskin-loader">
          <div className="flawskin-loader-content">
            <div className="flawskin-loader-logo">
              flaw<span>skin</span>
            </div>

            <div className="flawskin-loader-spinner"></div>

            <p>Beauty at your doorstep</p>
          </div>
        </div>
      )}
       <SEO
    title="Laser Hair Reduction at Home in Bangalore | FlawSkin"
    description="FlawSkin provides convenient laser hair reduction services at home across Bangalore. Book laser hair reduction for full body, face, underarms, legs, back and more."
    canonical="https://flawskin.com/"
  />
      <Navbar />
      <section>
        <div className="col-lg-12 col-md-12  pt-4">
          <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="0"
                className="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              ></button>
            </div>

            <div className="carousel-inner">
              <div className="carousel-item active">
               <img
                  src="/assets/assets/img/scroll1.webp"
                  className="d-block w-100 img-fluid"
                  width="1600"
                  height="500"
                  alt="FlawSkin laser hair reduction at home in Bangalore"
                  fetchPriority="high"
                />
              </div>
              <div className="carousel-item">
                <img
                  src="/assets/assets/img/scroll2.webp"
                  className="d-block w-100 img-fluid"
                  width="1600"
                  height="500"
                  alt="At-home laser hair reduction services by FlawSkin"
                  loading="lazy"
                />
              </div>
              {/* <div className="carousel-item">
                  <img
                    src="assets\assets\img\hiring.png"
                    className="d-block w-100 img-fluid"
                    alt="Third slide"
                  />
                </div> */}
            </div>

            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </section>

      <div className="container p-3  rounded mt-2 ">
        <div className="d-flex align-items-center">
          {/* Left Line */}
          <div
            style={{
              flex: 1,
              height: "2px",
              backgroundColor: "white",
            }}
          ></div>

          {/* SVG in the Middle */}
          <div
            style={{
              margin: "0 10px",
            }}
          >
            {/* Replace with your desired SVG */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              class="bi bi-gender-female"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5"
              />
            </svg>
            <div
              style={{
                marginTop: "5px",
                color: "black",
                fontSize: "15px",
                marginLeft: "-10px",
              }}
            >
              Female
            </div>
          </div>

          {/* Right Line */}
          <div
            style={{
              flex: 1,
              height: "2px",
              backgroundColor: "white",
            }}
          ></div>
        </div>
        <div className="row gy-2">
          {/* Button 1 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Trailsession")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-card-checklist"
                viewBox="0 0 16 16"
              >
                <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" />
                <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0" />
              </svg>
              <span className="ms-2">Trial Session</span>
            </button>
          </div>

          {/* Button 2 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Fullbody")}
            >
              <img
                src="assets/assets/img/fullbody.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />

              <span className="ms-2">Full Body</span>
            </button>
          </div>

          {/* Button 3 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Face")}
            >
              <img
                src="assets/assets/img/face svg.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />

              <span className="ms-2">Face</span>
            </button>
          </div>

          {/* Button 4 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Hands")}
            >
              <img
                src="assets/assets/img/hands.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />

              <span className="ms-2">Hands</span>
            </button>
          </div>

          {/* Button 5 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Underarms")}
            >
              <img
                src="assets/assets/img/arm.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Underarms</span>
            </button>
          </div>

          {/* Button 6 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Legs")}
            >
              <img
                src="assets/assets/img/legs.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />

              <span className="ms-2">Legs</span>
            </button>
          </div>

          {/* Button 7 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Back")}
            >
              <img
                src="assets/assets/img/Back (2).png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Back</span>
            </button>
          </div>

          {/* Button 8 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Bikini")}
            >
              <img
                src="assets/assets/img/bikini.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Bikini</span>
            </button>
          </div>

          {/* Button 9 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/ChestAbdomin")}
            >
              <img
                src="assets/assets/img/chest and abdomen.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Chest & Abdomen</span>
            </button>
          </div>

          {/* Button 10 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Buttocks")}
            >
              <img
                src="assets/assets/img/buttocks.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Buttocks</span>
            </button>
          </div>

          {/* Button 11 */}
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100 margin-left-sm"
              onClick={() => (window.location.href = "/Packages")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-box-seam"
                viewBox="0 0 16 16"
              >
                <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" />
              </svg>
              <span className="ms-2">Combo Packages</span>
            </button>
          </div>
        </div>

        {/* .............................................. MEN SERVICES............................................................... */}
        <div className="d-flex align-items-center mt-3">
          {/* Left Line */}
          <div
            style={{
              flex: 1,
              height: "2px",
              backgroundColor: "white",
            }}
          ></div>

          {/* SVG in the Middle */}
          <div
            style={{
              margin: "0 10px",
            }}
          >
            {/* Replace with your desired SVG */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              class="bi bi-gender-male"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
              />
            </svg>
            <div
              style={{
                marginTop: "5px",
                color: "black",
                fontSize: "15px",
                marginLeft: "-10px",
              }}
            >
              Male
            </div>
          </div>

          {/* Right Line */}
          <div
            style={{
              flex: 1,
              height: "2px",
              backgroundColor: "white",
            }}
          ></div>
        </div>
        <div className="row gy-2">
          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Commingsoon")}
            >
              <img
                src="assets/assets/img/menleg.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Legs</span>
            </button>
          </div>

          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Commingsoon")}
            >
              <img
                src="assets/assets/img/manhands.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Hands</span>
            </button>
          </div>

          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Commingsoon")}
            >
              <img
                src="assets/assets/img/arm.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Underarms</span>
            </button>
          </div>

          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Commingsoon")}
            >
              <img
                src="assets/assets/img/menback.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Back</span>
            </button>
          </div>

          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Commingsoon")}
            >
              <img
                src="assets/assets/img/beard.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Beard Shaping</span>
            </button>
          </div>

          <div className="col-6 col-sm-4 col-md-3">
            <button
              className="btn btn-light btn-ripple d-flex align-items-center justify-content-between w-100"
              onClick={() => (window.location.href = "/Commingsoon")}
            >
              <img
                src="assets/assets/img/menchest.png"
                alt="Button Image"
                style={{ width: "30px", height: "auto" }}
              />
              <span className="ms-2">Chest & Abdomen</span>
            </button>
          </div>
        </div>
      </div>

      <div className="text-center">
        <span className="badge rounded-pill bg-light text-dark border mt-4">
          Home Service Available Across Bangalore
        </span>
      </div>

      <div
        className="alert alert-primary d-flex align-items-center mt-3"
        role="alert"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          className="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
          viewBox="0 0 16 16"
          role="img"
          aria-label="Warning:"
        >
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </svg>
        <div>A travel allowance will be added for services.</div>
      </div>

      <div
        className="container d-flex justify-content-center align-items-center"
        //  style{height: 300px; border: 2px solid #000;">
        style={{ marginTop: "20px" }}
      >
        <img
      src="/assets/assets/img/home svg (1).svg"
      alt="FlawSkin at-home laser hair reduction service"
      className="img-fluid"
      width="1200"
      height="1200"
      loading="lazy"
      decoding="async"
      />
      </div>
      <div className="container">
        <h2 className="text-center p-1">Frequently Asked Questions</h2>
      </div>

      <div className="container mt-3">
        <div className="accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                is it is a safe method to treat all body areas ?
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
                All areas of the body like face, hands, legs, back, chest,
                abdomen, bikini, underarms can be safely treated. The laser hair
                reduction procedure is an effective procedure under the guidance
                of our dermatologists.
              </div>
            </div>
          </div>
          <div className="accordion-item mt-1">
            <h2 className="accordion-header" id="flush-headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTwo"
                aria-expanded="false"
                aria-controls="flush-collapseTwo"
              >
                How many LHR sessions are needed to see results ?
              </button>
            </h2>
            <div
              id="flush-collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingTwo"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
                Most of our clients will experience an immense change in
                thickness and growth of hair within 8 to 10 sessions. But,
                depending on the client’s age, hair type, and underlying
                hormonal condition, results may vary.
              </div>
            </div>
          </div>
          <div className="accordion-item mt-1">
            <h2 className="accordion-header" id="flush-headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseThree"
                aria-expanded="false"
                aria-controls="flush-collapseThree"
              >
                How to get started with the laser hair reduction treatment ?
              </button>
            </h2>
            <div
              id="flush-collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingThree"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
                You can book an online appointment with flawskin or call our
                office. Our customer care team will schedule an appointment with
                our expert dermatologist at your given convenience and preferred
                time.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12 col-md-12 mb-4 mb-md-0 mt-3">
        {/* <div class="container my-5"> */}
 <footer
          style={{
            backgroundColor: "#0F172A",
            color: "#94A3B8",
            fontFamily:
              "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
            borderTop: "1px solid rgba(255, 255, 255, 0.08)",
          }}
          className="pt-5"
        >
          <div className="container py-4">
            <div className="row g-4 justify-content-between">
              {/* Column 1: Brand Manifesto & Trust */}
              <div className="col-12 col-lg-4 col-md-6">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <span
                    className="fw-bold tracking-tight text-white fs-4"
                    style={{ letterSpacing: "-0.02em" }}
                  >
                    Flaw<span style={{ color: "#8dcae4" }}>Skin</span>
                  </span>
                  <span
                    className="badge rounded-pill px-2 py-0.5"
                    style={{
                      backgroundColor: "rgba(13, 148, 136, 0.2)",
                      color: "#8dcae4",
                      fontSize: "0.68rem",
                      border: "1px solid rgba(94, 234, 212, 0.3)",
                    }}
                  >
                    PVT LTD
                  </span>
                </div>

                <p
                  className="small mb-3"
                  style={{ lineHeight: "1.7", color: "#94A3B8" }}
                >
                  Founded in 2024, Flawskin Private Limited provides
                  dermatologically calibrated, painless triple-wavelength diode
                  laser hair reduction with personalized in-home convenience.
                </p>

                {/* Social Media Links */}
                <div className="d-flex gap-2">
                  <a
                    href="https://wa.me/917892644030?text=Hello%20Flawskin%2C%20I%20would%20like%20to%20inquire%20about%20laser%20hair%20removal."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-3 d-inline-flex align-items-center justify-content-center text-decoration-none"
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                      color: "#5EEAD4",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      transition: "all 0.2s ease",
                    }}
                    aria-label="WhatsApp"
                  >
                    <FaWhatsapp size={18} />
                  </a>

                  <a
                    href="https://www.instagram.com/flawskin_?igsh=MWpwMTViMzA4ajVqZA=="
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-3 d-inline-flex align-items-center justify-content-center text-decoration-none"
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                      color: "#F472B6",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      transition: "all 0.2s ease",
                    }}
                    aria-label="Instagram"
                  >
                    <FaInstagram size={18} />
                  </a>

                  <a
                    href="https://maps.app.goo.gl/TPrT9JWRdDFD2Cbx8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-3 d-inline-flex align-items-center justify-content-center text-decoration-none"
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                      color: "#FBBF24",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      transition: "all 0.2s ease",
                    }}
                    aria-label="Google Maps"
                  >
                    <FaMapMarkerAlt size={16} />
                  </a>
                </div>
              </div>

              {/* Column 2: Navigation Links */}
              <div className="col-6 col-lg-2 col-md-6">
                <span
                  className="text-uppercase fw-bold d-block mb-3"
                  style={{
                    fontSize: "0.75rem",
                    letterSpacing: "0.08em",
                    color: "#8dcae4",
                  }}
                >
                  Company
                </span>
                <ul className="list-unstyled d-flex flex-column gap-2 small">
                  <li>
                    <Link
                      to="/about"
                      className="text-decoration-none"
                      style={{ color: "#94A3B8" }}
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/request-call"
                      className="text-decoration-none"
                      style={{ color: "#94A3B8" }}
                    >
                      Book Patch Test
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/ContactUs"
                      className="text-decoration-none"
                      style={{ color: "#94A3B8" }}
                    >
                      Contact Desk
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/privacy"
                      className="text-decoration-none"
                      style={{ color: "#94A3B8" }}
                    >
                      Privacy & Terms
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Column 3: Contact & Clinical Address */}
              <div className="col-12 col-lg-3 col-md-6">
                <span
                  className="text-uppercase fw-bold d-block mb-3"
                  style={{
                    fontSize: "0.75rem",
                    letterSpacing: "0.08em",
                    color: "#8dcae4",
                  }}
                >
                  Contact Desk
                </span>
                <div className="d-flex flex-column gap-3 small">
                  <div className="d-flex align-items-start gap-2.5">
                    <FaMapMarkerAlt
                      size={16}
                      className="mt-1 flex-shrink-0"
                      style={{ color: "#8dcae4" }}
                    />
                    <span>
                     Anjanapura Village, 8th Phase, Anjanapura Twp, Vaddarapalya, Bengaluru, Karnataka 560108
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-2.5">
                    <FaPhoneAlt
                      size={14}
                      className="flex-shrink-0"
                      style={{ color: "#8dcae4" }}
                    />
                    <a
                      href="tel:+917892644030"
                      className="text-decoration-none text-white fw-medium"
                    >
                      +91 78926 44030
                    </a>
                  </div>
                  <div className="d-flex align-items-center gap-2.5">
                    <FaEnvelope
                      size={14}
                      className="flex-shrink-0"
                      style={{ color: "#8dcae4" }}
                    />
                    <a
                      href="mailto:contact@flawskin.com"
                      className="text-decoration-none"
                      style={{ color: "#94A3B8" }}
                    >
                      contact@flawskin.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Column 4: Clinical Operating Hours */}
              <div className="col-12 col-lg-3 col-md-6">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span
                    className="text-uppercase fw-bold"
                    style={{
                      fontSize: "0.75rem",
                      letterSpacing: "0.08em",
                      color: "#8dcae4",
                    }}
                  >
                    Service Hours
                  </span>
                  <span
                    className="badge rounded-pill px-2 py-0.5"
                    style={{
                      backgroundColor: "rgba(16, 185, 129, 0.15)",
                      color: "#34D399",
                      fontSize: "0.68rem",
                    }}
                  >
                    Sessions Active
                  </span>
                </div>

                <div
                  className="rounded-3 p-3"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.03)",
                    border: "1px solid rgba(255, 255, 255, 0.06)",
                  }}
                >
                  <div
                    className="d-flex justify-content-between py-1 border-bottom small"
                    style={{ borderColor: "rgba(255, 255, 255, 0.06)" }}
                  >
                    <span className="text-secondary">Mon – Thu</span>
                    <span className="text-white fw-medium">
                      8:00 AM – 8:00 PM
                    </span>
                  </div>
                  <div
                    className="d-flex justify-content-between py-1 border-bottom small"
                    style={{ borderColor: "rgba(255, 255, 255, 0.06)" }}
                  >
                    <span className="text-secondary">Fri – Sat</span>
                    <span className="text-white fw-medium">
                      8:00 AM – 8:00 PM
                    </span>
                  </div>
                  <div className="d-flex justify-content-between py-1 small">
                    <span className="text-secondary">Sunday</span>
                    <span className="text-white fw-medium">
                      9:00 AM – 8:00 PM
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Sub-Footer Copyright & Compliance Strip */}
            <div
              className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-4 mt-5 border-top gap-2"
              style={{
                borderColor: "rgba(255, 255, 255, 0.08)",
                fontSize: "0.82rem",
              }}
            >
              <div className="d-flex gap-3">
                <Link
                  to="/privacy"
                  className="text-decoration-none"
                  style={{ color: "#64748B" }}
                >
                  Privacy Policy
                </Link>
                <span style={{ color: "#334155" }}>•</span>
                <Link
                  to="/privacy#refund-cancellation"
                  className="text-decoration-none"
                  style={{ color: "#64748B" }}
                >
                  Cancellation & Refunds
                </Link>
                <span style={{ color: "#334155" }}>•</span>
                <Link
                  to="/ContactUs"
                  className="text-decoration-none"
                  style={{ color: "#64748B" }}
                >
                  Support
                </Link>
              </div>
            </div>
          </div>
        </footer>
        {/* </div> */}
      </div>
        {/* Floating Request a Call Button */}
      <button
        className="request-call-floating"
        onClick={() => (window.location.href = "/RequestCall")}
        aria-label="Request a Call"
      >
        {" "}
        <i className="fas fa-phone"></i>{" "}
        {showCallText && (
          <span className="request-call-text"> Request a Call </span>
        )}{" "}
      </button>
    </div>
  );
}
